import React, {useState, useRef, useEffect} from 'react';
import PropTypes from 'prop-types';
import {View} from 'react-native';
import {Menu} from 'react-native-paper';

const MenuControl = ({
  visible: visibleProp,
  onDismiss,
  onShow,
  anchor,
  style,
  contentStyle,
  children,
}) => {
  const [visible, setVisible] = useState(false);
  const menuRef = useRef(null);

  const onShowMenu = () => {
    setVisible(true);
    // Work around for the fact that the menu ref is not yet assigned before measuring takes place.
    // See Menu.tsx in react-native-paper.
    requestAnimationFrame(menuRef.current.show);

    if (onShow) {
      onShow();
    }
  };

  useEffect(() => {
    setVisible(visibleProp);
  }, [visibleProp]);

  return (
    <Menu
      ref={(ref) => {
        menuRef.current = ref;
        if (menuRef.current) {
          // HACK: For iOS home screen web apps, the menu is dismissed as soon as the menu is shown due to size changes. So we remove the listener.
          const attachListeners = menuRef.current.attachListeners;
          menuRef.current.attachListeners = () => {
            attachListeners();
            menuRef.current.dimensionsSubscription?.remove();
            menuRef.current.dimensionsSubscription = null;
          };
        }
      }}
      visible={visible}
      onDismiss={() => {
        setVisible(false);
        if (onDismiss) {
          onDismiss();
        }
      }}
      anchor={
        <View
          style={{
            cursor: 'pointer',
            background: 'none',
            border: 'none',
            padding: 0,
            margin: 0,
          }}
          onClick={onShowMenu}>
          {anchor}
        </View>
      }
      style={style}
      contentStyle={contentStyle}>
      {children}
    </Menu>
  );
};

MenuControl.propTypes = {
  visible: PropTypes.bool,
  onDismiss: PropTypes.func,
  onShow: PropTypes.func,
  anchor: PropTypes.any,
  style: PropTypes.any,
  contentStyle: PropTypes.any,
  children: PropTypes.any,
};

export default MenuControl;
